<template>
    <div>
    </div>
</template>

<script>

export default {
    name: "servicePage",
    data() {
        return {
            loading:null,
        }
    },
    mounted () {
        this.myStore.setIsServeringAction(true);
        this.servicePage();
    },
    destroyed () {
        this.myStore.clearIsServeringAction();
        this.loading.close();
    },
    methods: {
        servicePage() {
            this.loading = this.$loading({
                lock: true,
                text: '设备正在维护中',
                spinner: 'el-icon-loading',
                background: '#4c4c4c'
            });
        }
    }
}
</script>

<style scoped>

</style>